import React from "react";
import { CheckCircle2, Circle } from "lucide-react";

const requirements = [
  { label: "At least 8 characters", test: (pwd) => pwd?.length >= 8 },
  { label: "One uppercase letter (A-Z)", test: (pwd) => /[A-Z]/?.test(pwd) },
  { label: "One number (0-9)", test: (pwd) => /[0-9]/?.test(pwd) },
  { label: "One special character (!@#$…)", test: (pwd) => /[^A-Za-z0-9]/?.test(pwd) },
];

const PasswordRequirements = ({ password }) => {
  return (
    <div className="p-3 bg-muted/40 rounded-lg border border-border space-y-1.5">
      <p className="text-xs font-medium text-muted-foreground mb-2">Password requirements:</p>
      {requirements?.map((req, index) => {
        const met = req?.test(password);
        return (
          <div key={index} className="flex items-center gap-2">
            {met ? (
              <CheckCircle2 className="w-3.5 h-3.5 text-green-500 flex-shrink-0" />
            ) : (
              <Circle className="w-3.5 h-3.5 text-gray-300 flex-shrink-0" />
            )}
            <span className={`text-xs ${met ? "text-green-700" : "text-muted-foreground"}`}>
              {req?.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PasswordRequirements;
